import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, ICrudGetAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './auth-user-import.reducer';
import { IAuthUserImport } from 'app/shared/model/auth-user-import.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IAuthUserImportDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const AuthUserImportDetail = (props: IAuthUserImportDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { authUserImportEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          <Translate contentKey="examsysApp.authUserImport.detail.title">AuthUserImport</Translate> [<b>{authUserImportEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="tel">
              <Translate contentKey="examsysApp.authUserImport.tel">Tel</Translate>
            </span>
          </dt>
          <dd>{authUserImportEntity.tel}</dd>
          <dt>
            <span id="createDate">
              <Translate contentKey="examsysApp.authUserImport.createDate">Create Date</Translate>
            </span>
          </dt>
          <dd>
            {authUserImportEntity.createDate ? (
              <TextFormat value={authUserImportEntity.createDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="examsysApp.authUserImport.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>
            {authUserImportEntity.startDate ? (
              <TextFormat value={authUserImportEntity.startDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="examsysApp.authUserImport.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>
            {authUserImportEntity.endDate ? (
              <TextFormat value={authUserImportEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="code">
              <Translate contentKey="examsysApp.authUserImport.code">Code</Translate>
            </span>
          </dt>
          <dd>{authUserImportEntity.code}</dd>
        </dl>
        <Button tag={Link} to="/auth-user-import" replace color="info">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/auth-user-import/${authUserImportEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ authUserImport }: IRootState) => ({
  authUserImportEntity: authUserImport.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AuthUserImportDetail);
